// extracted by mini-css-extract-plugin
export default {"tag":"style_tag__DYeHt"};